import AnalyzedTextEnglish from './AnalyzedTextEnglish';
import AnalyzedTextSpanish from './AnalyzedTextSpanish';
import AnalyzedTextCatalan from './AnalyzedTextCatalan';
import AnalyzedTextRussian from './AnalyzedTextRussian';

export interface AnalyzedTextProps {
    task_id: string;
    analyzedText: any;
    saveFormattedTextCallback: CallableFunction;
    language?: string;
}

export default function AnalyzedText(props: AnalyzedTextProps) {
    const language = props.language || 'en';

    switch (language) {
        case 'en':
            return <AnalyzedTextEnglish {...props} />;
        case 'es':
            return <AnalyzedTextSpanish {...props} />;
        case 'ca':
            return <AnalyzedTextCatalan {...props} />;
        case 'ru':
            return <AnalyzedTextRussian {...props} />;
        default:
            return <AnalyzedTextEnglish {...props} />;
    }
}
